// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2hiJ5","validationTips":"StatementDescriptor_validationTips__2_C2C"};